const TOGGLED = "active";
const TOGGLED_CLASS = 'attached';

/**
 * @code
 *  new ToggleableComponent('.toggle-button', 'togglable-component', () => {})
 */

export default class ToggleableComponent {
  /**
   *
   * @param button
   * @param component
   * @param onClickOutside: if set as function, then it will be set up click outside element
   */
  constructor(button = false, component = false, onClickOutside = false) {
    this.button = button;
    if (component)
      this.component = component;
    else
      this.component = button;

    this.clickOutsideHandler = onClickOutside;

    this._setup();
  }

  activate() {
    this.button.classList.add(TOGGLED);
    this.component.classList.add(TOGGLED);
    this._toggled(true);
  }

  deactivate() {
    this.button.classList.remove(TOGGLED);
    this.component.classList.remove(TOGGLED);
    this._toggled(false);
  }

  _toggled(toggled) {
    if (typeof this.toggleCallback !== "undefined") {
      this.toggleCallback(toggled);
    }

    if (!!this.clickOutsideHandler) {
      const outsideSearchClickListener = event => {
        if (!this.button.parentElement.contains(event.target) && this._toggled) {
          this.deactivate();
          removeClickListener();
        }
      }

      const removeClickListener = () => {
        document.removeEventListener('click', outsideSearchClickListener);
      }

      if (toggled) {
        if (typeof this.clickOutsideHandler === 'function') {
          this.clickOutsideHandler();
        }
        // Add outside click listener.
        document.addEventListener('click', outsideSearchClickListener);
      }
      else {
        // Remove outside click listener.
        removeClickListener();
      }
    }
  }

  _setup() {
    if (!this.button || !this.component) {
      console.warn("No button found.");
      return;
    }

    // Check if the component listener has already been attached.
    if (!this.button.classList.contains(TOGGLED_CLASS)) {
      this.button.classList.add(TOGGLED_CLASS);
      this.component.classList.add(TOGGLED_CLASS);

      this.button.addEventListener("click", () => {
        if (!this.button.classList.contains(TOGGLED)) {
          this.activate();
        } else {
          this.deactivate();
        }
      });
    }


  }
}
